import moment from 'moment';

import {
  CUSTOM_DATE_SEARCH_TYPE,
  PAST_WEEK_SEARCH_TYPE,
  PAST_MONTH_SEARCH_TYPE,
  OPEN_ORDERS_SEARCH_TYPE,
} from 'utils/constants';

const getSearchTermError = ({ searchTerm }) => {
  const trimmedTerm = searchTerm.trim();

  if (!trimmedTerm) {
    return "Search term can't be empty.";
  } else if (trimmedTerm.length > 60) {
    return 'Search term is too long. 60 characters max.';
  } else {
    return '';
  }
};

const getSearchDateError = (fieldName, fields) => {
  const date = fields[fieldName];

  if (!date) {
    return "Date can't be empty.";
  } else if (!moment(date).isValid()) {
    return 'This is not a valid date.';
  } else if (!moment(fields.orderDateStart).isBefore(moment(fields.orderDateEnd))) {
    return 'Start date must be before end date.';
  } else {
    return '';
  }
};

// Returns an object of { fieldName: errorMessage } if any error is found
export const getFormErrors = (fields) => {
  let errors = null;

  if (fields.searchType === CUSTOM_DATE_SEARCH_TYPE) {
    const dateStartError = getSearchDateError('orderDateStart', fields);
    const dateEndError = getSearchDateError('orderDateEnd', fields);
    const hasDateError = dateStartError || dateEndError;

    errors = hasDateError
      ? {
          orderDateStart: dateStartError,
          orderDateEnd: dateEndError,
        }
      : null;
  } else if (
    fields.searchType !== PAST_WEEK_SEARCH_TYPE &&
    fields.searchType !== PAST_MONTH_SEARCH_TYPE &&
    fields.searchType !== OPEN_ORDERS_SEARCH_TYPE
  ) {
    const termError = getSearchTermError(fields);
    errors = termError ? { searchTerm: termError } : null;
  }

  return errors;
};
